export class FlagshipShowcase {
    removeClasses(elements) {
        [...elements].map(element => {
            element.classList.remove('active');
        });
    }

    init() {
        const block = document.querySelectorAll('.nf-flagship-showcase-block');

        if ( ! block ) {
            return;
        }

        [...block].map((element, index) => {
            const card_elements = element.querySelectorAll('.nf-flagship-showcase-block__card');
            const details_elements = element.querySelectorAll('.nf-flagship-showcase-block__details__item');
    
            [...card_elements].map((element, index) => {
                element.addEventListener('click', () => {
                    this.removeClasses(card_elements);
                    this.removeClasses(details_elements);
                    
                    element.classList.add('active');
                    details_elements[index].classList.add('active');
                });
            });
        });
    }
}

window.addEventListener('load', () => {
    (new FlagshipShowcase()).init();
});